import { NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { MoxiPreloaderService } from '@shared/services';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'moxi-ui-mobile-notification',
  imports: [
    RouterModule,
    NgOptimizedImage,

    TranslatePipe,

    // Ant Design
    NzCardModule,
    NzButtonModule,
    NzIconModule
  ],
  templateUrl: './mobile-notification.component.html',
  styleUrls: ['./mobile-notification.component.scss']
})
export class MobileNotificationComponent implements OnInit {
  private readonly preloader = inject(MoxiPreloaderService);
  private readonly modal = inject(NzModalRef);

  // App store links
  appStoreLink = `https://apps.apple.com/us/app/moxi-driver/id6741531330`;
  playStoreLink = `https://play.google.com/store/apps/details?id=com.moxi.driverapp`;

  ngOnInit(): void {
    this.preloader.removeMoxiPreloader();
  }

  onDestroyModal(): void {
    this.modal.destroy();
  }
}
